import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-menu-3" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "col-xl-1 col-lg-2 col-md-4" }
const _hoisted_5 = { class: "dropdown profile-dropdown justify-content-end" }
const _hoisted_6 = {
  class: "dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_7 = { class: "title d-none d-lg-block ms-10 ms-lg-15" }
const _hoisted_8 = { class: "d-block fw-bold mb-5 mb-md-8" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-body-emphasis fw-semibold fs-13" }, "Admin", -1)
const _hoisted_10 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_11 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_12 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1)

import { onMounted, ref } from 'vue'
import { usePageStore } from '@/store/page'
import { useSessionStore } from '@/store/sessions'
import { storeToRefs } from 'pinia'
import router from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'MainHeader',
  setup(__props) {

const pageStore = usePageStore()
const sessions = useSessionStore()
const { profile } = storeToRefs(sessions)

const isSticky = ref(false)

onMounted(() => {
  window.addEventListener('scroll', () => {
    let scrollPos = window.scrollY
    isSticky.value = scrollPos >= 100
  })
  // console.log(sessionsProfile.profile)
})
const handleOpenBurgerMenu = () => {
  pageStore.toggleOpenMenu()
}

const handleLogOut = () => {
  pageStore.setPageLoading(true)
  sessions.doLogout()
  setTimeout(() => {
    pageStore.setPageLoading(false)
    router.push({
      name: 'login'
    })
  }, 1500)

}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["dark", [
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
      { sticky: isSticky.value },
    ]]),
    id: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", { class: "col-xl-11 col-lg-10 col-md-8" }, [
        _createElementVNode("div", { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center" }, [
          _createElementVNode("button", {
            class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
            id: "header-burger-menu",
            onClick: handleOpenBurgerMenu
          }, _hoisted_3)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(profile).firstname) + " " + _toDisplayString(_unref(profile).lastname), 1),
              _hoisted_9
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("ul", _hoisted_11, [
              _createElementVNode("li", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" Logout "),
                _createVNode(_component_router_link, {
                  to: "#",
                  class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleLogOut()))
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}
}

})